// Waktu WIB untuk chat: pemisah tanggal (Hari ini/Kemarin/tanggal) dan jam "09.12".
const WIB = 7 * 3600000;
const hari = (ms) => Math.floor((ms + WIB) / 86400000);
const BULAN = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
export function labelTanggal(iso, sekarang = Date.now()) {
  const t = new Date(iso).getTime();
  const b = hari(sekarang) - hari(t);
  if (b === 0) return "Hari ini";
  if (b === 1) return "Kemarin";
  const d = new Date(t + WIB);
  return `${d.getUTCDate()} ${BULAN[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}
export function jamWib(iso) {
  const d = new Date(new Date(iso).getTime() + WIB);
  return `${String(d.getUTCHours()).padStart(2, "0")}.${String(d.getUTCMinutes()).padStart(2, "0")}`;
}
export const sisipTanggal = (pesan, sekarang = Date.now()) => {
  const keluar = [];
  let akhir = null;
  for (const p of pesan) {
    const l = labelTanggal(p.dibuat_pada, sekarang);
    if (l !== akhir) { keluar.push({ pemisah: l, kunci: `t-${p.id}` }); akhir = l; }
    keluar.push(p);
  }
  return keluar;
};
/** Gabung pesan baru: tanpa kembar, urut id, tanda Dibaca. Respons kirim bisa lebih baru dari balasan yang belum terambil polling, jadi urutan tidak boleh mengikuti waktu datang. */
export const gabungPesan = (lama, baru, dibacaSampai = 0, pengirim = "pembeli") => {
  const ada = new Map(lama.map((p) => [p.id, p]));
  for (const p of baru) if (!ada.has(p.id)) ada.set(p.id, p);
  const hasil = [...ada.values()].sort((a, b) => a.id - b.id);
  return dibacaSampai ? hasil.map((p) => (p.pengirim === pengirim && p.id <= dibacaSampai && !p.dibaca ? { ...p, dibaca: true } : p)) : hasil;
};
